import { useEffect, useRef } from "react";
import { useSocket } from "@/providers/socket-provider";
import { useWorkspaceStore } from "@/store/workspace-store";

export function useWorkspaceSocket() {
  const { socket, isConnected } = useSocket();
  const { activeWorkspaceId } = useWorkspaceStore();
  const previousWorkspaceRef = useRef<string | null>(null);

  useEffect(() => {
    if (!socket || !isConnected) return;

    const prevWs = previousWorkspaceRef.current;

    // Leave previous workspace room
    if (prevWs && prevWs !== activeWorkspaceId) {
      socket.emit("workspace:leave", { workspaceId: prevWs });
    }

    // Join new workspace room
    if (activeWorkspaceId) {
      socket.emit("workspace:join", { workspaceId: activeWorkspaceId });
      previousWorkspaceRef.current = activeWorkspaceId;
    }

    return () => {
      // Leave room on cleanup
      if (activeWorkspaceId) {
        socket.emit("workspace:leave", { workspaceId: activeWorkspaceId });
      }
    };
  }, [socket, isConnected, activeWorkspaceId]);
}
